import React from 'react';
import styles from './Strategy.module.css';

const AI_TRANSFORMATION_STEPS = [
  {
    id: 'ambition',
    icon: '🎯',
    title: 'AI Ambition',
    description: 'Align with your AI strategy'
  },
  {
    id: 'prioritise',
    icon: '📊',
    title: 'Prioritise High-Value Use Case',
    description: 'Business case prioritisation'
  },
  {
    id: 'discovery',
    icon: '🔍',
    title: 'Data Discovery',
    description: 'Executive sponsorship'
  },
  {
    id: 'innovation',
    icon: '🚀',
    title: 'Fast Innovation',
    description: 'Implementation Phases'
  }
];

function Strategy() {
  return (
    <section className={styles.section} id="strategy">
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Our Strategy</h2>
        
        <div className={styles.strategyGrid}>
          {/* AI Transformation Cycle */}
          <div className={styles.cycleContainer}>
            {/* <h3 className={styles.cycleTitle}>AI Transformation Cycle</h3> */}
            <h3 className={styles.mobileTitle}>AI Transformation</h3>
            <div className={styles.cycleWrapper}>
              <div className={styles.cycle}>
                <div className={styles.cycleCenter}>
                  <div className={styles.cycleCenterText}>AI TRANSFORMATION</div>
                </div>
                
                {AI_TRANSFORMATION_STEPS.map((step, index) => (
                  <React.Fragment key={step.id}>
                    <div 
                      className={`${styles.cycleStep} ${styles[`step${index + 1}`]}`}
                    >
                      <div className={styles.stepIcon}>{step.icon}</div>
                      <div className={styles.stepContent}>
                        <div className={styles.stepTitle}>{step.title}</div>
                        <div className={styles.stepDescription}>{step.description}</div>
                      </div>
                    </div>
                    {index < AI_TRANSFORMATION_STEPS.length - 1 && (
                      <div className={styles.mobileConnector}></div>
                    )}
                  </React.Fragment>
                ))}
                
                {/* Cycle arrows */}
                <div className={styles.cycleArrow1}></div>
                <div className={styles.cycleArrow2}></div>
                <div className={styles.cycleArrow3}></div>
                <div className={styles.cycleArrow4}></div>
              </div>
            </div>
          </div>

          {/* Vision/Mission/Value Pyramid */}
          <div className={styles.pyramidContainer}>
            {/* <h3 className={styles.pyramidTitle}>Vision, Mission & Values</h3> */}
            <div className={styles.pyramid}>
              <div className={styles.pyramidLayer}>
                <div className={styles.layerLabel}>VISION</div>
                <div className={styles.layerContent}>
                Leveraging advanced technology to streamline processes, enhance efficiency, and automate critical airport operations
                </div>
              </div>
              
              <div className={styles.pyramidLayer}>
                <div className={styles.layerLabel}>MISSION</div>
                <div className={styles.layerContent}>
                Helping aviation harness AI and continuous innovation to create business impact
                </div>
              </div>
              
              <div className={styles.pyramidLayer}>
                <div className={styles.layerLabel}>CORE VALUES</div>
                <div className={styles.layerContent}>
                Revolutionizing airport operations through smarter AI integration
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Strategy;
